import { faList } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { Trans } from '@lingui/react/macro';

export const FieldDetailEmptyState = () => (
  <div className="vai-flex-1 vai-flex vai-flex-col vai-items-center vai-justify-center vai-p-8 vai-text-center">
    <div className="vai-w-16 vai-h-16 vai-rounded-lg vai-bg-gray-200 vai-flex vai-items-center vai-justify-center vai-mb-4">
      <FontAwesomeIcon
        icon={faList}
        className="vai-h-8 vai-w-8 vai-text-gray-500"
      />
    </div>
    <p className="vai-text-base vai-font-semibold vai-text-gray-900 vai-mb-2">
      <Trans>Select a field to begin</Trans>
    </p>
    <p className="vai-text-sm vai-text-gray-600 vai-max-w-sm">
      <Trans>
        Choose a field from the list to view and modify its available values.
      </Trans>
    </p>
  </div>
);
